import { FC } from 'react';

import { IcBack32Icon, IcClose32Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconButton, IconViewSizes } from '@gem/ui-kit';

import styles from './BackgroundPanelHeader.styles.m.css';

interface IBackgroundPanelHeaderProps {
  isCompact?: boolean;
  onClose(): void;
}

export const BackgroundPanelHeader: FC<IBackgroundPanelHeaderProps> = (props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.headerContainer}>
      {props.isCompact && (
        <IconButton
          theme={'21'}
          size={IconViewSizes.Big}
          Icon={IcBack32Icon}
          onClick={props.onClose}
          className={styles.backButton}
        />
      )}
      <div className={styles.title}>{t('call_backgrounds')}</div>

      {!props.isCompact && (
        <IconButton
          theme={'12'}
          size={IconViewSizes.Big}
          Icon={IcClose32Icon}
          onClick={props.onClose}
          className={styles.closeButton}
        />
      )}
    </div>
  );
};
